import 'reflect-metadata';

export const Inject = (target: any, key: string) => {
  const getter = () => {
    const t = Reflect.getMetadata('design:type', target, key);
    return new t();
  };
  // This was previously guarded by `if (delete this[key])`. At module top level
  // `this` is module.exports under CommonJS (an object, so the delete was a
  // no-op returning true) but is `undefined` under ES modules -- which threw
  // "Cannot convert undefined or null to object" inside reflect-metadata's
  // decorator loop and killed the whole app at module-evaluation time.
  // The guard never did anything useful: `delete` on an absent key is always
  // true, so defineProperty always ran. Removing it is behaviour-preserving
  // under CommonJS and is what makes ESM output work.
  Object.defineProperty(target, key, {
    get: getter,
  });
};

export const splitArr = <T>(arr: T[], n: number) => {
  const res: T[][] = [];
  for (let i = 1; i <= n + 1; i++) {
    res.push(arr.slice((i - 1) * n, i * n));
  }
  return res;
};

export function fromGlobalId(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  const id = decodeURIComponent(atob(str).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join('')).split(':');
  return Number(id[id.length - 1]);
}

export function toGlobalId(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode(('0x' + p1) as any);
    }));
}
